import { motion } from 'framer-motion'

export default function AnimatedBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(43,92,115,0.22),_transparent_34%),linear-gradient(180deg,_#132522_0%,_#1C1E1D_55%,_#161917_100%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(115deg,transparent_0%,rgba(165,106,67,0.12)_35%,transparent_60%)]" />

      <motion.div
        className="absolute -top-24 left-[8%] h-80 w-80 rounded-full bg-copper/10 blur-3xl"
        animate={{
          x: [0, 45, 0],
          y: [0, -30, 0],
        }}
        transition={{
          duration: 22,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      <motion.div
        className="absolute right-[4%] top-[22%] h-96 w-96 rounded-full bg-river/10 blur-3xl"
        animate={{
          x: [0, -50, 0],
          y: [0, 35, 0],
        }}
        transition={{
          duration: 24,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1.5,
        }}
      />

      <motion.div
        className="absolute bottom-[-10rem] left-1/4 h-[28rem] w-[28rem] rounded-full bg-forest/14 blur-3xl"
        animate={{
          x: [0, -35, 0],
          y: [0, 25, 0],
        }}
        transition={{
          duration: 28,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 4,
        }}
      />

      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:96px_96px] opacity-[0.18]" />
    </div>
  )
}
